export default function UserProfileCard({ isClose, avatar, defaultAvatar, name, surname, roleLabel, isCustomerUser, notificationBell }) {
    return (
        <div className={`w-full border-b border-slate-300 flex justify-start items-center p-2 gap-2 h-[55px]`}>
            {/* Icona user per tutti gli utenti - ridotta */}
            <div 
                className={`${isClose ? 'w-5 h-5' : 'w-8 h-8'} transform-all duration-300 ease-in-out rounded-full flex items-center justify-center flex-shrink-0 ${isCustomerUser ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'}`}
            >
                <i className={`fi fi-br-user ${isClose ? 'text-xs' : 'text-sm'}`}></i>
            </div>
            {!isClose && (
                <>
                    <div className="gsap-opacize-me flex-grow leading-4 min-w-0">
                        <div className="font-medium text-sm truncate">{name || 'Utente'} {surname || ''}</div>
                        <div className="text-xs text-slate-400 leading-3 truncate">{roleLabel || 'Utente'}</div>
                    </div>
                    {/* Campanella notifiche a destra */}
                    {notificationBell && (
                        <div className="flex-shrink-0">
                            {notificationBell}
                        </div>
                    )}
                </>
            )}
        </div>
    )
}
